import script from "./Communities.vue?vue&type=script&setup=true&lang=ts"
export * from "./Communities.vue?vue&type=script&setup=true&lang=ts"

import "./Communities.vue?vue&type=style&index=0&id=45d7eabb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d7eabb"]])

export default __exports__